import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { setupForDark } from '@theme';

export default function InputErrorMessage({ error }: { error: string }) {
  const { t } = useTranslation();
  return (
    error && (
      <div
        className={classNames(
          'flex flex-row items-center justify-start gap-xxs',
          'P5R',
          setupForDark('text-error')
        )}
      >
        <div>{t(error)}</div>
      </div>
    )
  );
}
